import { AxiosResponse } from 'axios';
import { $http } from '@/plugins/axios';

export const formEvaluationService = {
    list: (search: any, is_reference: boolean): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/assessment_forms?query=${search}&is_reference=${is_reference}`);
    },
    detail: (id: any, is_reference: boolean): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/assessment_forms/${id}?is_reference=${is_reference}`);
    },
    createForm: (params: any): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/assessment_forms`,
            params,
        );
    },
    changeFormName: (id: any, params: any): Promise<AxiosResponse> => {
        return $http.put(`v1/org_admin/assessment_forms/${id}`,
            params,
        );
    },
    duplicateForm: (formId: any, isReference = false): Promise<AxiosResponse> => {
        const referenceQuery = isReference ? '?is_reference=true' : '';
        return $http.post(
            `v1/org_admin/assessment_forms/${formId}/duplicate${referenceQuery}`
        );
    },
    deleteForm: (formId: any): Promise<AxiosResponse> => {
        return $http.delete(`v1/org_admin/assessment_forms/${formId}`);
    },
    addGoalToForm: (formId: any, params: any): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/assessment_forms/${formId}/copy`,
            params,
        );
    },
    deleteGoalFromForm: (formId: any, goalId: any): Promise<AxiosResponse> => {
        return $http.delete(`v1/org_admin/assessment_forms/${formId}/library_items/${goalId}`);
    },
    studentFormDetail: (id: any, formId: any): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/students/${id}/student_assessment_forms/${formId}`);
    },
    createFormForStudent: (id: any, params: any): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/students/${id}/student_assessment_forms`,
            params,
        );
    },
    updateFormForStudent: (id: any, formId: any, params: any): Promise<AxiosResponse> => {
        return $http.put(`v1/org_admin/students/${id}/student_assessment_forms/${formId}`,
            params,
        );
    },
    addGoalFromFormToStudent: (id: any, params: any): Promise<AxiosResponse> => {
        return $http.post(`v1/staff/students/${id}/goals/create_goals_from_library_items`,
            params,
        );
    },
    copyAllGoalFromFormToStudent: (id: any, formId: any, params: any, is_reference: boolean): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/students/${id}/student_assessment_forms/${formId}/copy_goals_from_assessment_form?is_reference=${is_reference}`,
            params,
        );
    },
    listStaffForms: (params: {
        state: string;
        page?: number;
        page_size?: number;
    }): Promise<AxiosResponse> => {
        return $http.get('v1/staff/student_assessment_forms', { params });
    },
    listStudentHaveForm: (): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/students_have_student_assessment_form`);
    },
    listFormOfStudent: (id: any): Promise<AxiosResponse> => {
        return $http.get(`v1/org_admin/students/${id}/student_assessment_forms`);
    },
    copyGoalFromStudent: (studentId: any, params: any): Promise<AxiosResponse> => {
        return $http.post(`v1/staff/students/${studentId}/goals/copy_goals_to_library`,
            params,
        );
    },
    copyAllGoalFromStudentToStudent: (studentId: any, formId: any, params: any): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/students/${studentId}/student_assessment_forms/${formId}/copy_goals_from_student_assessment_form`,
            params,
        );
    },
    addGoalFromLib: (studentId: any, params: any): Promise<AxiosResponse> => {
        return $http.post(`v1/staff/students/${studentId}/goals/create_goals_from_library_items`,
            params,
        );
    },
    duplicateStudentForm: (studentId: any, params: any): Promise<AxiosResponse> => {
        return $http.post(`v1/org_admin/students/${studentId}/student_assessment_forms/duplicate`,
            params
        );
    },
    deleteStudentForm: (studentId: any, formId: any): Promise<AxiosResponse> => {
        return $http.delete(`v1/org_admin/students/${studentId}/student_assessment_forms/${formId}`);
    },
    sendForm: (studentId: any, formId: any, params: any): Promise<AxiosResponse> => {
        return $http.put(`v1/org_admin/students/${studentId}/student_assessment_forms/${formId}`,
            params
        );
    },
    deleteGoalFromStudentForm: (studentId: any, params: any): Promise<AxiosResponse> => {
        return $http.delete(`v1/staff/students/${studentId}/goals`,
            params
        );
    }
};
